import { createAction, props } from '@ngrx/store';
import { ExpenseEntryGridConfigModel } from 'app/core/mips/common/models/expense-entry-grid-config.model';

export const setExpenseEntryGridConfig = createAction('[ExpenseEntryGridConfig] Set ExpenseEntryGridConfig', props<{ expenseEntryGridConfig: ExpenseEntryGridConfigModel }>());
export const clearExpenseEntryGridConfig = createAction('[ExpenseEntryGridConfig] Clear ExpenseEntryGridConfig');